import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const HeaderWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const Title = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  font-family: 'Manrope', sans-serif;
  font-weight: ${({ active }) => (active ? 600 : 400)};
  color: ${({ active }) => (active ? "#0c53bb" : "#5a6c87")};
  transition: color 0.15s ease;

  /* Invisible semibold twin reserves the active-weight width so the
     segmented control doesn't jitter when the weight changes. */
  &::after {
    content: attr(data-heading);
    height: 0;
    overflow: hidden;
    visibility: hidden;
    font-weight: 600;
  }
`;

const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #0c53bb;
  color: #ffffff;
  font-family: 'Manrope', sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  font-variant-numeric: tabular-nums;
`;

const TabHeader = ({ heading, widgets, active }) => {
  return (
    <HeaderWrapper>
      <Title active={active} data-heading={heading}>
        {heading}
      </Title>
      {widgets
        .filter((item) => (item.count ?? 0) > 0)
        .map((item) => (
          <CountBadge
            key={item.heading}
            aria-label={`${item.heading}: ${item.count}`}
          >
            {item.count > 99 ? "99+" : item.count}
          </CountBadge>
        ))}
    </HeaderWrapper>
  );
};

TabHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  widgets: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      count: PropTypes.number,
    })
  ).isRequired,
  active: PropTypes.bool,
};

export default TabHeader;
